// @flow

import React from 'react';
import { Button, Flex, SPACING } from 'clark-styles';
import CancelButton from 'components/button-cancel';
import ModalAndTrigger from 'containers/modal-and-trigger';
import type { SessionType, SessionsType } from 'types/sessions';
import EditIcon from 'assets/icons/edit.svg';

import { Copy, Headline, ModalCopy, StyledButton, Wrapper } from './styles';

type PropsType = {
  isEditRecurringEnabled: boolean,
  remainingRecurringSessions: SessionType[],
  session: SessionType,
  sessions: SessionsType,
};

const { S_1 } = SPACING;
const EXPLAINER_COPY =
  'This session is part of a recurring series. Editing this and following will change all future events.';

const EditSession = ({
  isEditRecurringEnabled,
  remainingRecurringSessions,
  session: { id: sessionId },
  sessions,
}: PropsType) =>
  isEditRecurringEnabled ? (
    <ModalAndTrigger
      modalContentLabel="Edit-Session Modal"
      renderModalTrigger={toggleModal => (
        <Button
          layout="fullWidth"
          styleType="outlineSecondary"
          icon={<EditIcon />}
          onClick={toggleModal}
          margin={`0 0 ${S_1}`}
        >
          Edit Session
        </Button>
      )}
      renderModalContent={toggleModal => (
        <Wrapper>
          <Flex justifyContent="space-between">
            <Headline>Edit recurring or individual</Headline>
            <CancelButton onClick={toggleModal} />
          </Flex>
          <Copy>{EXPLAINER_COPY}</Copy>
          <Flex flexDirection="column">
            <StyledButton
              path={{
                pathname: `/sessions/${sessionId}/edit`,
                state: { shouldUpdateFutureSessions: false },
              }}
              layout="fullWidth"
              styleType="solid"
              margin={`0 0 ${S_1}`}
            >
              <ModalCopy>Only this instance</ModalCopy>
            </StyledButton>
            <Button
              path={{
                pathname: `/sessions/${sessionId}/edit`,
                state: { shouldUpdateFutureSessions: true, sessions },
              }}
              layout="fullWidth"
              styleType="outlineSecondary"
            >
              <ModalCopy>{`This and ${remainingRecurringSessions.length -
                1} following sessions`}</ModalCopy>
            </Button>
          </Flex>
        </Wrapper>
      )}
    />
  ) : (
    <Button
      path={`/sessions/${sessionId}/edit`}
      layout="fullWidth"
      styleType="outlineSecondary"
      icon={<EditIcon />}
      margin={`0 0 ${S_1}`}
    >
      Edit Session
    </Button>
  );

export default EditSession;



// WEBPACK FOOTER //
// ./src/containers/sessions/edit-form/modal/index.js